import { useEffect, useRef, useState } from 'react'

import { useUserData } from '../../../../../../../hooks'
import {
  getMockApplicantsComparison,
  postMockApplicantDecision,
} from '../../../../../../RentalPortalApplicant'
import {
  APPLICANT_DECISION_ACTION,
  getIsApplicantBlockConflictError,
} from '../../../../../RentalPortalApplicantProfile'
import { getApplicantComparisonItems } from '../../RentalPortalApplicantComparison.utils'

export function useApplicantComparison({ listingId }) {
  const currentUser = useUserData()

  const [reloadKey, setReloadKey] = useState(0)

  const [response, setResponse] = useState(null)
  const [hasError, setError] = useState(false)
  const [conflictKey, setConflictKey] = useState(null)

  const [isInitiated, setInitiated] = useState(false)
  const [isLoading, setLoading] = useState(true)

  const readIdRef = useRef(0)

  function loadComparison() {
    readIdRef.current += 1

    const readId = readIdRef.current

    setLoading(true)

    getMockApplicantsComparison({ listing_id: listingId })
      .then(({ data }) => {
        if (readIdRef.current === readId) {
          setResponse(data)
          setError(false)
        }
      })
      .catch(() => {
        if (readIdRef.current === readId) {
          setError(true)
        }
      })
      .finally(() => {
        if (readIdRef.current === readId) {
          setLoading(false)
          setInitiated(true)
        }
      })
  }

  useEffect(() => {
    if (listingId) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- the in-flight flag flips when the read starts
      loadComparison()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `loadComparison` is re-created every render; only a new listing or an explicit reload re-reads the grid
  }, [listingId, reloadKey])

  function handleRefresh() {
    setInitiated(false)
    setError(false)
    setReloadKey(prevReloadKey => prevReloadKey + 1)
  }

  async function submitSelect({ applicantId, note }) {
    setConflictKey(null)

    try {
      await postMockApplicantDecision({
        action: APPLICANT_DECISION_ACTION.select,
        applicantId,
        currentUser,
        note,
      })
    } catch (error) {
      if (!getIsApplicantBlockConflictError(error)) {
        throw error
      }

      setConflictKey('RentalPortal.ApplicantDecisionConflictKey')
    }

    setReloadKey(prevReloadKey => prevReloadKey + 1)
  }

  return {
    conflictKey,
    handleRefresh,
    hasError,
    isInitiated,
    isLoading,
    items: getApplicantComparisonItems(response),
    submitSelect,
  }
}
